import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'enumToArray'
})
export class EnumToArrayPipe implements PipeTransform {
	public transform(data: object) {
		// todo: add translation in pipe
		const keys = Object.keys(data);
		return keys;
	}
}
